<script>
export default {
    methods: {
        log(data) {
            console.log(data);
        }
    }
}
</script>